<template>
  <div>
    <b-container fluid class="mx-0">
      <v-row>
        <v-col cols="12" md="4" class="elevation-2">
          <registration-info></registration-info>
        </v-col>
        <v-col cols="12" md="4" class="sober elevation-2">
          <application-status-card></application-status-card>
          <div class="my-2">
            <v-btn class="success" v-on:click="download">Download this registration data</v-btn>
          </div>
        </v-col>
        <v-col cols="12" md="4" class="sober elevation-2">
          <file-action-list></file-action-list>
        </v-col>
      </v-row>
    </b-container>
  </div>
</template>

<script>
import FileActionList from "../owner-info-action/FileActionList.vue";
import RegistrationInfo from "../owner-info-action/RegistrationInfo.vue";
import ApplicationStatusCard from "../owner-info-action/ApplicationStatusCard.vue";

export default {
  name: "Ownerinfocard",
  components: {
    RegistrationInfo,
    ApplicationStatusCard,
    FileActionList,
  },
  methods: {
    download() {
      const url = `/api/registration/${this.$route.params.id}/download-data`;
      // console.log("user token "+ this.userToken );
      this.$axios
        .get(url, {
          responseType: "blob",
        })
        .then((response) => {
          // console.log("response headers " + JSON.stringify(response.headers));
          let filename = "download.zip"; // fallback
          const disposition = response.headers["content-disposition"];
          // console.log("dispositon: " + disposition);

          if (disposition) {
            const match = disposition.match(/filename\*=utf-8''([^;]+)/);
            if (match) {
              // filename = match[1];
              filename = decodeURIComponent(match[1]);
              console.log("decoded filename: " + filename);
            }
          }

          const blob = new Blob([response.data], { type: response.data.type });
          const objectUrl = URL.createObjectURL(blob);
          // this.content = objectUrl;
          const link = document.createElement("a");
          link.href = objectUrl;
          link.setAttribute("download", filename); // sets filename
          document.body.appendChild(link);
          link.click();

          // cleanup
          link.remove();
          window.URL.revokeObjectURL(objectUrl);
          // this.isLoading = false;
        })
        .catch(() => {
          // this.isLoading = false;
          console.error("Download failed:", error);
        });
    },
  },
};
</script>

<style scoped>
.v-btn.v-btn--has-bg.border-primary {
  border: 1px solid var(--v-primary-base) !important;
}
</style>
